var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right publish-sign" },
    [
      _c(
        "div",
        { staticClass: "upload-file" },
        [
          this.$store.getters.authUser.identityAuth > -1
            ? [
                _c("el-button", { attrs: { size: _vm.size, type: "danger" } }, [
                  _vm._v(_vm._s(_vm.fileText))
                ]),
                _c("input", {
                  attrs: { type: "file" },
                  on: {
                    change: function($event) {
                      return _vm.handleInputChange($event)
                    }
                  }
                })
              ]
            : [
                _c(
                  "el-button",
                  {
                    attrs: { size: _vm.size, type: "danger" },
                    on: {
                      click: function($event) {
                        _vm.authDialog = true
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.fileText))]
                )
              ]
        ],
        2
      ),
      _c(
        "el-button",
        {
          staticClass: "tpl",
          attrs: { type: "success", size: _vm.size },
          on: { click: _vm.toTpl }
        },
        [_vm._v(_vm._s(_vm.tplText))]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.authDialog, title: "实名认证", width: "475px" },
          on: {
            "update:visible": function($event) {
              _vm.authDialog = $event
            }
          }
        },
        [
          _c("p", { staticClass: "authDialog" }, [
            _c("img", {
              attrs: { src: require("../../static/images/warning.png") }
            }),
            _vm._v("您还未完成实名认证，认证后才能执行该操作。\n    ")
          ]),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    border: "none",
                    background: "#ec1c1c",
                    color: "#ffffff"
                  },
                  attrs: { size: "small" },
                  on: { click: _vm.gotoAuth }
                },
                [_vm._v("去认证")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb7e820e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb7e820e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/publish-sign/index.vue
// module id = Ts7Q
// module chunks = 0 1 94